import { useTranslation } from "react-i18next";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PageHero from "@/components/PageHero";
import SkipToContent from "@/components/SkipToContent";
import ScrollReveal from "@/components/ScrollReveal";

const Terms = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <SkipToContent />
      <Header />
      <main id="main-content">
        <PageHero
          title={t("terms.title")}
          subtitle={t("terms.subtitle")}
        />

        <section className="section-padding">
          <div className="container-wide max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="prose prose-neutral dark:prose-invert max-w-none">
                <h2 className="font-display text-2xl mb-4">{t("terms.sections.acceptance.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("terms.sections.acceptance.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("terms.sections.services.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("terms.sections.services.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("terms.sections.intellectual.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("terms.sections.intellectual.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("terms.sections.liability.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("terms.sections.liability.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("terms.sections.termination.title")}</h2>
                <p className="text-muted-foreground mb-8">
                  {t("terms.sections.termination.content")}
                </p>

                <h2 className="font-display text-2xl mb-4">{t("terms.sections.governing.title")}</h2>
                <p className="text-muted-foreground">
                  {t("terms.sections.governing.content")}
                </p>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
